// 放一些只有浏览器能用的东西
import * as ColorUtils from './ColorUtil'
import * as DomUtils from './DomUtils'
import * as ImageUtils from './ImageUtils'

export * from './nativeEvents'
export * from './userAgent'
export * from './navigation'

export {
  ColorUtils,
  DomUtils,
  ImageUtils,
}
export { saveAs, FileSaverOptions } from 'file-saver'
